module.exports = __webpack_public_path__ + "static/media/openbrix@3x.e7098e7f.png";